module.exports = __webpack_public_path__ + "assets/Delta.56722fa49aeb6f731fdd1b9347e477b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Delta.png
// module id = 831
// module chunks = 0